module.exports = __webpack_public_path__ + "media/customizations/mygcplife/back-dd26acc90129450ecbc6b4bf48245157.jpg";